import React from 'react'
import { View } from 'react-native'
import { Text } from 'react-native-paper'
import { composeStyle } from '../../../../common-frontend/src/helpers'

export const Hr = ({ style }) => (
  <View
    style={composeStyle(
      { borderBottomColor: '#F0F0F0', borderBottomWidth: 1, flex: 1 },
      style,
    )}
  />
)

export const TextWithHorizontalLine = ({ children, containerStyle }) => (
  <View
    style={[{ flexDirection: 'row', alignItems: 'center' }, containerStyle]}
  >
    <Hr />
    <Text style={{ textAlign: 'center', marginHorizontal: 20 }}>
      {children}
    </Text>
    <Hr />
  </View>
)
